<template>
  <v-container
    class="control-content" fluid
    :class="{'control-content--preview_demo' : previewDemo && !isDisplayMode('widget')}"
  >
    <v-row>
      <v-col fluid>
        <template v-if="type === 'inline' && !previewDemo">
          <h2 class="control-content__title">{{ $t('control.widget.inline.title') }}</h2>

          <p class="control-content__text">{{ $t('control.widget.inline.p1') }}</p>
          <p class="control-content__text">{{ $t('control.widget.inline.p2') }}</p>
        </template>

        <template v-if="type === 'frame' && !previewDemo">
          <h2 class="control-content__title">{{ $t('control.widget.frame.title') }}</h2>

          <p class="control-content__text">{{ $t('control.widget.frame.p1') }}</p>
        </template>

        <div class="control-content__widget">
          <slot></slot>
        </div>

        <EmbedCode v-show="!previewDemo"></EmbedCode>

        <template v-if="type === 'inline' && !previewDemo">
          <p class="control-content__text">{{ $t('control.widget.inline.p3') }}</p>
          <p class="control-content__text">{{ $t('control.widget.inline.p4') }}</p>
        </template>


      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import EmbedCode from "./EmbedCode";
import {useStore} from "vuex";
import {computed} from "vue";

export default {
  components: {
    EmbedCode,
  },
  props: {
    type: {
      type: String,
      default: 'widget',
    },
  },

  setup() {
    const store = useStore();

    const previewDemo = computed(() => {
      return store.getters['control/previewDemo'];
    });
    const isDisplayMode = computed(() => {
      return store.getters['control/isDisplayMode'];
    });

    return {
      previewDemo,
      isDisplayMode,
    }
  }
};
</script>

<style lang="scss">
.control-content {
  $this: 'control-content';

  &__title {
    font-size: 24px;
    margin-bottom: 25px;
  }

  &__text {
    font-size: 14px;
    font-weight: 300;
    margin-bottom: 15px;
  }

  &__widget {
    margin: 25px 0;
  }

  &.#{$this}--preview_demo {
    display: flex;

    @media screen and (max-width: 599px) {
      & > .v-row {
        display: flex;
        & > .v-col {
          display: flex;
        }
      }

      .control-content__widget {
        padding-top: 20px;
        margin: 0 !important;
        display: flex;

        #kwizbot_widget.showAfterCssLoaded {
          display: flex !important;
          & > div {
            display: flex;

            .sc-chat-window {

              position: fixed;
              top: 40px;
              left: 16px;
              right: 16px;
              bottom: 10px;
              width: calc(100% - 32px);

              //width: 100%;
              height: calc(100dvh - 85px);

              @media not all and (min-resolution:.001dpcm) {
                height: calc(100vh - 85px);
              }

              .sc-message {
                width: unset !important;
              }
            }

            //INLINE MODE
            .device-frame {
              display: flex;
              flex-direction: column;

              .sc-chat-window {
                position: static;
                width: 100%;
                height: calc(100dvh - 140px);

                @media not all and (min-resolution:.001dpcm) {
                  height: calc(100vh - 140px);
                }
              }
            }

          }
        }
      }
    }
  }
}
</style>
